import { useKV } from "@/hooks/use-kv-adapter";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Warning, TrendUp, TrendDown } from "@phosphor-icons/react";

export function PredictiveAnalytics() {
  // Mock predictions
  const [predictions] = useKV<any[]>("analytics-attrition", [
    { id: "1", employeeName: "John Doe", department: "Sales", riskScore: 85, riskLevel: "High", reason: "Low engagement, missed targets" },
    { id: "2", employeeName: "Alice Smith", department: "Engineering", riskScore: 45, riskLevel: "Medium", reason: "Salary below market average" },
    { id: "3", employeeName: "Bob Johnson", department: "Marketing", riskScore: 12, riskLevel: "Low", reason: "Stable performance" },
  ]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="border-l-4 border-l-red-500">
          <CardHeader>
            <CardTitle>Attrition Forecast</CardTitle>
            <CardDescription>Predicted turnover rate for next quarter</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex items-end gap-2">
              <span className="text-4xl font-bold text-red-600">12%</span>
              <span className="text-sm text-red-500 mb-1 flex items-center">
                <TrendDown className="mr-1" /> +2% vs last Q
              </span>
            </div>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-green-500">
          <CardHeader>
            <CardTitle>Hiring Demand</CardTitle>
            <CardDescription>Projected open roles based on growth</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex items-end gap-2">
              <span className="text-4xl font-bold text-green-600">15</span>
              <span className="text-sm text-green-500 mb-1 flex items-center">
                <TrendUp className="mr-1" /> Expanding
              </span>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>At-Risk Employees</CardTitle>
          <CardDescription>AI-identified retention risks</CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Employee</TableHead>
                <TableHead>Department</TableHead>
                <TableHead>Risk Level</TableHead>
                <TableHead>Key Factors</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {predictions.map((p) => (
                <TableRow key={p.id}>
                  <TableCell className="font-medium">{p.employeeName}</TableCell>
                  <TableCell>{p.department}</TableCell>
                  <TableCell>
                    <Badge variant="outline" className={
                      p.riskLevel === 'High' ? 'bg-red-100 text-red-700 border-red-200' :
                      p.riskLevel === 'Medium' ? 'bg-amber-100 text-amber-700 border-amber-200' :
                      'bg-green-100 text-green-700 border-green-200'
                    }>
                      {p.riskLevel}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-slate-500">{p.reason}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
